module.exports = __webpack_public_path__ + "static/media/main_visual_articulated_loader_mla_t_516_75_h_manitou.cdbc68e0.png";